import { createStore } from "vuex";
import VuexPersistence from "vuex-persist";

const vuexLocal = new VuexPersistence({
  storage: window.localStorage,
});

export default createStore({
  state: {
    vehicleId: null,
  },
  getters: {
    GET_VEHICLE_ID(state) {
      return state.vehicleId;
    },
  },
  mutations: {
    SET_VEHICLE_ID(state, vehicleId) {
      state.vehicleId = vehicleId;
    },
  },
  actions: {},
  modules: {},
  plugins: [vuexLocal.plugin],
});
